module.exports = __webpack_public_path__ + "img/danox-logo.f44f72e9.svg";